// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1l7UL","header":"ReportDetails_header__1y4yo","title":"ReportDetails_title__3rIfH","left":"ReportDetails_left__24gdr"};